import {
    SET_NO_OF_DOORS,
} from "./NoOfDoorsType";

const initialState = {
    noOfDoorsDropDown: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_NO_OF_DOORS:
            return {
                ...state,
                noOfDoorsDropDown: action.noOfDoorsDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
